// Gig-related socket actions
import { formatGig } from "../../services/controllers/helperFunctions";

const sharedModule = require("../../shared.js").default;
let { socket } = sharedModule;

export const createGigActions = (store) => {
  return {
    // GIGS
    addOrUpdateGigData(value) {
      const { ID } = value;
      const objectKeys = Object.keys(value);
      // set currentGig
      if (!store.currentGig) {
        store.currentGig = value;
        this.addGigSubscription(ID);
      } else if (store.currentGig.ID === value.ID) {
        for (const key of objectKeys) {
          store.currentGig[key] = value[key];
        }
      } else {
        store.currentGig = value;
        this.addGigSubscription(ID);
      }
    },

    addGigSubscription(ID) {
      if (store.gigSubscription) {
        socket.off(store.gigSubscription);
      }
      const idStr = `GIG-${ID}`;
      store.gigSubscription = idStr;
      socket.on(idStr, (data) => {
        this.addOrUpdateGigData(formatGig(data));
      });
    },
  };
};
